export default __webpack_public_path__ + "static/media/img-guide-gt-popup-2-es_es.0b70f050.png";